import FootballState from "../../../state/football-state";
import Returned from "../returned";

export default class NoRecoveryKickReturn extends Returned {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return fragment.associatedState === FootballState.NoRecoveryKickReturn;
    }
}
